module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-10-min.b88f4b41.jpg";